import React from 'react';
import { Stack } from '@mui/material';
import PageFooter from '@ui-lib/components/PageLayout/components/PageFooter';
import { useBolAuthToken } from '../BolDetails/components/DeliveryTokenContext';
import AcceptButton from './components/AcceptButton';
import RejectButton from './components/RejectButton';
import AcceptWithDiscrepanciesButton from './components/AcceptWithDiscrepanciesButton';
import { EbolActionProps } from './components/EbolActionModal/types';

const EbolDetailsFooter = (props: EbolActionProps) => {
  const token = useBolAuthToken();

  if (!token) {
    return null;
  }
  return <PageFooter>
    <Stack spacing={0.5} width={'100%'}>
      <Stack direction={'row'} spacing={1} width={'100%'}>
        <AcceptButton {...props} />
        <RejectButton {...props} />
      </Stack>
      <AcceptWithDiscrepanciesButton {...props} />
    </Stack>
  </PageFooter>;
};

export default EbolDetailsFooter;